import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import Loader from '../../components/loader/Loader';
import SearchTable from '../../components/search/SearchTable';
import { urls } from '../../services/Server';
import './Search.css';

export default class Search extends Component {
  /*
    This component is listing equities, and a search bar. When the user adds input to the
    search bar, the equities will automatically update with results matching the query.
  */

  constructor(props) {
    super(props);

    this.state = {
      equities: [],
      equitiesLoaded: false
    };

    this.loadEquities();
  }

  equitiesLoaded = equities => {
    this.setState({
      equities,
      equitiesLoaded: true
    });
  };

  loadEquities = () =>
    fetch(urls.equity, { credentials: 'include' })
      .then(response => response.json())
      .then(json => {
        this.equitiesLoaded(json);
      });

  render() {
    return (
      <Row>
        <div className="box search-box">
          <div className="header">
            <h2> {this.props.pageName} </h2>
          </div>
          {this.state.equitiesLoaded ? (
            <SearchTable equities={this.state.equities} />
          ) : (
            <Loader />
          )}
        </div>
      </Row>
    );
  }
}

Search.propTypes = {
  pageName: PropTypes.string.isRequired
};
